import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import staticTranslations from './staticTranslations';

export const loadTranslationResources = (clientTranslations) => {

  const translationResources = {};

  for(const language in clientTranslations) {
    translationResources[language] = {
      translation: {
        ...staticTranslations[language],
        ...clientTranslations[language]
      }
    };
  }

  i18n
  // // detect user language
  // // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed - React escapes by default
    },
    resources: translationResources
  });  
};

export default i18n;
